<template>
  <div class="child-bg-image">
    <div class="bg-image-section" />
    <div class="content-section">
      <staff-check-in-page /><br><br><br>
    </div>
  </div>
</template>

  <script>
  import StaffCheckInPage from '../../../Components/Staff/StaffCheckInPage.vue';
    export default {
      name: 'StaffCheckInPage',
      components: {
        'staff-check-in-page': StaffCheckInPage,
    },
  };
  </script>

  <style scoped>

  </style>
